export const lightLightGray = '#efefef';
export const darkGray = '#4b4b4b';
export const black = '#000';
export const fontColor = black;
export const lightGray = '#dfe0df';
export const mediumGray = '#c2c2c2';
export const ctaGreen = '#1cc532';
export const darkBlue = '#3f5391';
export const red = '#cc2530';
export const orange = '#ec962f';



// WEBPACK FOOTER //
// ./src/styleGuide/colors.js